import EngineerTeamChannelContainer from '../../components/EngineerTeamChannelContainer'

export default function EngineerDashboardTeamChannel() {
  return (
    <div className="px-4 sm:px-6 lg:px-8">
      <EngineerTeamChannelContainer />
    </div>
  )
}
